export const DEFAULTADDRESS = "DEFAULT_ADDRESS"
export const USERMESSAGE = "USER_MESSAGES"
export const CITYCONTRACT = "CITYCONTRACT"
export const USERLOGINADDRESS = "USERLOGINADDRESS"
export const UserBuyingCities = "User_Buying_Cities"
export const USERCONSTRUCT = "USERCONSTRUCT"